import { dataStructure } from '@goldwasserexchange/oblis-frontend-utils';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import * as React from 'react';
import { AccountTypePresentationTable, AccountTypeWithOnboardingTable } from '../../../AccountType';

export const ServiceTableSection = () => (
  <ouiDom.HeadingSection.HeadingSection
    index={4}
    name="ServiceTableSection"
    paddingVertical={4}
    paddingHorizontal="simple"
    container={ouiStyle.Constants.Container.xl}
  >
    <AccountTypePresentationTable />
  </ouiDom.HeadingSection.HeadingSection>
);

export const ServiceTableSectionWithOnboardingLink = (props: {
  currentAccountType: dataStructure.accountType.listType,
}) => {
  const {
    currentAccountType,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={4}
      name="ServiceTableSection"
      paddingVertical={4}
      paddingHorizontal="simple"
      container={ouiStyle.Constants.Container.xl}
    >
      <AccountTypeWithOnboardingTable
        currentAccountType={currentAccountType}
      />
    </ouiDom.HeadingSection.HeadingSection>
  );
};
